import { createRouter, createWebHistory } from 'vue-router';
import { isLoggedIn } from '@/utility/auth'; // Importa la funzione di verifica
import Recaptcha from '@/classes/Recaptcha'; // Importa la classe Recaptcha
import ErrorHandler from '@/classes/ErrorHandler';
import { useAuthStore } from '@/stores/authStore';
import { useListStore } from '@/stores/listStore';
import i18n from '@/i18n';

const routes = [
	{
		path: '/login',
		alias: ['/de/login', '/en/login'],
		name: 'login',
		component: () => import('@/views/LoginView.vue'),
	},
	{
		path: '/logout',
		alias: ['/de/logout', '/en/logout'],
		name: 'logout',
		redirect: (to: any) => {
			const isGerman = to.path.startsWith('/de/');
			const isEnglish = to.path.startsWith('/en/');
			return isGerman ? '/de/login' : isEnglish ? '/en/login' : '/login';
		},
	},
	{
		path: '/sportello-territoriale',
		alias: ['/de/gebietsschalter', '/en/territorial-office'],
		name: 'sportello-territoriale',
		component: () => import('@/views/FormSportelloTerritorialeView.vue'),
	},
	{
		path: '/documenti',
		alias: ['/de/dokumente', '/en/documents'],
		name: 'documenti',
		component: () => import('@/views/FormSportelloTerritorialeView.vue'),
	},
	{
		path: '/aggiorna-dati-ricontatto',
		alias: ['/de/kontaktdaten-aktualisieren', '/en/update-contact-details'],
		name: 'aggiorna-dati-ricontatto',
		component: () => import('@/views/FormAggiornaEmailView.vue'),
		meta: { requiresAuth: true, requiresRecaptcha: true },
	},
	{
		path: '/segnalazione',
		alias: ['/de/meldung', '/en/report'],
		name: 'segnalazione',
		component: () => import('@/views/FormSegnalazioneView.vue'),
		meta: { requiresAuth: true, requiresRecaptcha: true },
	},
	{
		path: '/segnalazione/chat/:email/:id',
		alias: ['/de/meldung/chat/:email/:id', '/en/report/chat/:email/:id'],
		name: 'segnalazioneChat',
		component: () => import('@/views/PingPongSegnalazioneView.vue'),
		meta: { requiresRecaptcha: true },
		props: (route: { name: string }) => ({ name: route.name })
	},
	{
		path: '/segnalazione/chat/operatore/:email/:id',
		alias: ['/de/meldung/chat/operator/:email/:id', '/en/report/chat/operator/:email/:id'],
		name: 'segnalazioneChatOperatore',
		component: () => import('@/views/PingPongSegnalazioneView.vue'),
		meta: { requiresRecaptcha: true },
		props: (route: { name: string }) => ({ name: route.name })
	},
	{
		path: '/richiesta/chat/:email/:id',
		alias: ['/de/anfrage/chat/:email/:id', '/en/request/chat/:email/:id'],
		name: 'dichiarazioneChat',
		component: () => import('@/views/PingPongSegnalazioneView.vue'),
		meta: { requiresRecaptcha: true },
		props: (route: { name: string }) => ({ name: route.name })
	},
	{
		path: '/richiesta/chat/operatore/:email/:id',
		alias: ['/de/anfrage/chat/operator/:email/:id', '/en/request/chat/operator/:email/:id'],
		name: 'dichiarazioneChatOperatore',
		component: () => import('@/views/PingPongSegnalazioneView.vue'),
		meta: { requiresRecaptcha: true },
		props: (route: { name: string }) => ({ name: route.name })
	},
	{
		path: '/area-riservata',
		alias: ['/de/geschutzter-bereich', '/en/reserved-area'],
		name: 'areaRiservata',
		component: () => import('@/views/AreaRiservataView.vue'),
		meta: { requiresAuth: true, requiresRecaptcha: true },
	},
	{
		path: '/area-riservata/documenti/:idRappresentanza/:enteDocumento',
		alias: ['/de/geschutzter-bereich/dokumente/:idRappresentanza/:enteDocumento', '/en/reserved-area/documents/:idRappresentanza/:enteDocumento'],
		name: 'areaRiservataDocumenti',
		component: () => import('@/views/AreaRiservataDocumentiView.vue'),
		meta: { requiresAuth: true, requiresRecaptcha: true },
	},
	{
		path: '/area-riservata/profilo-utente',
		alias: ['/de/geschutzter-bereich/benutzerprofil', '/en/reserved-area/user-profile'],
		name: 'profiloUtente',
		component: () => import('@/views/ProfiloUtenteView.vue'),
		meta: { requiresAuth: true, requiresRecaptcha: true },
	},
	//QUI
	{
		path: '/servizio/:form(rateizza-un-pagamento/|rinegozia-un-pagamento/|riesame/|affissione-manifesti/|istanza-contribuente/)',
		alias: ['/de/dienstleistung/:form(ratenzahlung-beantragen/|neuverhandlung-zahlung/|uberprufung/|plakatierung/|antrag-steuerpflichtiger/)', '/en/service/:form(payment-installment/|renegotiate-a-payment/|review/|bill-posting/|taxpayer-request/)'],
		redirect: (to: any) => {
			return to.path.slice(0, -1);
		}
	},
	{
	path: '/servizio/:form(rateizza-un-pagamento|rinegozia-un-pagamento|riesame|affissione-manifesti|istanza-contribuente)',
		alias: ['/de/dienstleistung/:form(ratenzahlung-beantragen|neuverhandlung-zahlung|uberprufung|plakatierung|antrag-steuerpflichtiger)', '/en/service/:form(payment-installment|renegotiate-a-payment|review|bill-posting|taxpayer-request)'],
		name: 'selectPosizioneICP',
		component: () => import('@/views/SelectPosizioneView.vue'),
		meta: { requiresAuth: true, requiresRecaptcha: true },
	},
	{
		path: '/servizio/allacciamento-lampade-votive',
		alias: ['/de/dienstleistung/anschluss-von-votivlampen', '/en/service/votive-lamp-connection'],
		name: 'nuovoAllacciamento',
		component: () => import('@/views/FormNuovoAllacciamentoView.vue'),
		meta: { requiresAuth: true, requiresRecaptcha: true },
	},
	{
		path: '/servizio/delega-imposta-soggiorno',
		alias: ['/de/dienstleistung/delegation-tourismussteuer', '/en/service/tourist-tax-delegation'],
		name: 'delegaImpostaSoggiorno',
		component: () => import('@/views/FormDelegaImpostaSoggiorno.vue'),
		meta: { requiresAuth: false, requiresRecaptcha: true },
	},
	{
		path: '/servizio/abilitazione-struttura-ricettiva',
		alias: ['/de/dienstleistung/ermachtigung-beherbergungsstruktur', '/en/service/accommodation-facility-authorization'],
		name: 'abilitazioneStrutturaRicettiva',
		component: () => import('@/views/FormAbilitazioneStrutturaRicettiva.vue'),
		meta: { requiresAuth: false, requiresRecaptcha: true },
	},
	{
		path: '/servizio/rateizza-un-pagamento/:ws_service/:docs',
		alias: ['/de/dienstleistung/ratenzahlung-beantragen/:ws_service/:docs', '/en/service/payment-installment/:ws_service/:docs'],
		name: 'rateizzazione',
		component: () => import('@/views/FormRateizzazioneView.vue'),
		meta: { requiresRecaptcha: true },
	},
	{
		// http://abaco.test:4173/servizio/rinegozia-un-pagamento/CRC/QUJBQ09BODZBMDFMNDA3QToxNDAwMzI1OA==
		path: '/servizio/rinegozia-un-pagamento/:ws_service/:docs',
		alias: ['/de/dienstleistung/neuverhandlung-zahlung/:ws_service/:docs', '/en/service/renegotiate-a-payment/:ws_service/:docs'],
		name: 'proroga',
		component: () => import('@/views/FormProrogaView.vue'),
		meta: { requiresRecaptcha: true },
	},
	{
		// http://abaco.test:4173/servizio/riesame/CRC/SFVYTFlJODRMMDdaMjEwWjoxMzkxMTExNQ==
		path: '/servizio/riesame/:ws_service/:docs', // crc
		alias: ['/de/dienstleistung/uberprufung/:ws_service/:docs', '/en/service/review/:ws_service/:docs'],
		name: 'riesame',
		component: () => import('@/views/FormRiesameView.vue'),
		meta: { requiresAuth: true, requiresRecaptcha: true },
	},
	{
		// http://abaco.test:4173/servizio/affissione-manifesti
	path: '/servizio/affissione-manifesti',
		alias: ['/de/dienstleistung/plakatierung', '/en/service/bill-posting'],
		name: 'affissione-manifesti',
		component: () => import('@/views/FormAffissioneManifestiView.vue'),
		meta: { requiresAuth: true, requiresRecaptcha: true },
	},
	{
		// http://abaco.test:4173/servizio/locandine
		path: '/servizio/locandine',
		alias: ['/de/dienstleistung/plakate', '/en/service/posters'],
		name: 'locandine',
		component: () => import('@/views/FormLocandineView.vue'),
		meta: { requiresAuth: true, requiresRecaptcha: true },
	},
	{
		// http://abaco.test:4173/servizio/abbonamento-parcheggi
	path: '/servizio/abbonamento-parcheggi',
		alias: ['/de/dienstleistung/parkabonnement', '/en/service/parking-subscription'],
		name: 'abbonamentoParcheggi',
		component: () => import('@/views/FormAbbonamentoParcheggiView.vue'),
		meta: { requiresRecaptcha: true },
	},
	{
		// http://abaco.test:4173/servizio/mezzo-permanente/0/a00R200000K1GQbIAN
		// http://abaco.test:4173/servizio/mezzo-permanente/0
		//TODO: prevedere che si arrivi senza step
		path: '/servizio/mezzo-permanente/:step?/:id?',
		alias: ['/de/dienstleistung/dauerhaftes-werbemittel/:step?/:id?', '/en/service/permanent-advertising-medium/:step?/:id?'],
		name: 'mezzoPermanente',
		component: () => import('@/views/FormMezzoPermanenteController.vue'),
		meta: { requiresAuth: true },
	},
	{
		path: '/servizio/variazione-cessazione-mezzo-pubblicitario',
		alias: ['/de/dienstleistung/anderung-beendigung-werbemittel', '/en/service/change-termination-of-advertising-medium'],
		redirect: (to: any) => {
			// Preserva la lingua nel redirect
			const isGerman = to.path.startsWith('/de/');
			const isEnglish = to.path.startsWith('/en/');
			return isGerman 
				? '/de/dienstleistung/dauerhaftes-werbemittel'
				: isEnglish
				? '/en/service/permanent-advertising-medium'
				: '/servizio/mezzo-permanente';
		}
	},
	{
		path: '/servizio/istanza-contribuente/:ws_service/:docs', // TARI
		alias: ['/de/dienstleistung/antrag-steuerpflichtiger/:ws_service/:docs', '/en/service/taxpayer-request/:ws_service/:docs'],
		name: 'istanza-contribuente',
		component: () => import('@/views/FormIstanzaContribuenteView.vue'),
		meta: { requiresAuth: true, requiresRecaptcha: true },
	},
	{
		// http://abaco.test:4173/servizio/stragiudiziale
		path: '/servizio/stragiudiziale',
		alias: ['/de/dienstleistung/aussergerichtlich', '/en/service/out-of-court'],
		name: 'stragiudiziale',
		component: () => import('@/views/FormStragiudizialeView.vue'),
		meta: { requiresAuth: true, requiresRecaptcha: true },
	},
	{
	path: '/servizio/paga-online',
		alias: ['/de/dienstleistung/online-bezahlen', '/en/service/pay-online'],
		name: 'pagaOnline',
		component: () => import('@/views/FormPagaOnline.vue'),
		meta: { requiresRecaptcha: true },
	},
	{
		path: '/pagopa-online-precompilato/:codiceEnte/:codiceServizio',
		alias: ['/de/pagopa-online-vorausgefullt/:codiceEnte/:codiceServizio', '/en/pagopa-online-prefilled/:codiceEnte/:codiceServizio'],
		name: 'paga-online-precompilato',
		component: () => import('@/views/FormPagaOnlinePrecompilato.vue'),
		meta: { requiresRecaptcha: true },
	},
	{
		path: '/servizio/paga-online/pago-pa/esito',
		alias: ['/de/dienstleistung/online-bezahlen/pago-pa/ergebnis', '/en/service/pay-online/pago-pa/result'],
		name: 'pagamento-result',
		component: () => import('@/views/PagoPaResultView.vue'),
	},
	{
		path: '/:catchAll(.*)',
		name: 'catchAll',
		component: () => import('@/views/PageNotFoundView.vue'),
	},
];

const router = createRouter({
	routes,
	history: createWebHistory(import.meta.env.BASE_URL),
	linkActiveClass: 'active', // imposta una classe css custom sui link padri e tutti i figli che sono navigati in quel momento
	scrollBehavior(_, _2, savedPosition) {
		// quando torno indietro posizione lo schermo allo stesso punto
		// //console.log(top, from, savedPosition);
		if (savedPosition) return savedPosition;
	},
});

// Aggiungi il navigation guard globale
router.beforeEach(async (to, from, next) => {
	// Rileva e imposta la lingua in base all'URL
	if (to.path.startsWith('/de/')) {
		i18n.global.locale.value = 'de';
		localStorage.setItem('locale', 'de');
	} else if (to.path.startsWith('/en/')) {
		i18n.global.locale.value = 'en';
		localStorage.setItem('locale', 'en');
	} else {
		i18n.global.locale.value = 'it';
		localStorage.setItem('locale', 'it');
	}

	const isLogged = await isLoggedIn();

	// se sono loggato e vado su una delle seguenti pagine, vado direttamente in area riservata
	// per evitare di inserisce una richiesta dalla form sbagliata
	if (
		isLogged &&
		[
			'/servizio/rateizza-un-pagamento',
			'/servizio/rateizza-un-pagamento/',
			'/de/dienstleistung/ratenzahlung-beantragen',
			'/de/dienstleistung/ratenzahlung-beantragen/',
			'/en/service/payment-installment',
			'/en/service/payment-installment/',
			'/servizio/rinegozia-un-pagamento',
			'/servizio/rinegozia-un-pagamento/',
			'/de/dienstleistung/neuverhandlung-zahlung',
			'/de/dienstleistung/neuverhandlung-zahlung/',
			'/en/service/renegotiate-a-payment',
			'/en/service/renegotiate-a-payment/',
			'/servizio/riesame',
			'/servizio/riesame/',
			'/de/dienstleistung/uberprufung',
			'/de/dienstleistung/uberprufung/',
			'/en/service/review',
			'/en/service/review/',
			'/servizio/istanza-contribuente',
			'/servizio/istanza-contribuente/',
			'/de/dienstleistung/antrag-steuerpflichtiger',
			'/de/dienstleistung/antrag-steuerpflichtiger/',
			'/en/service/taxpayer-request',
			'/en/service/taxpayer-request/',
			// ... altri path
		].includes(to.fullPath)
	) {
		// Preserva la lingua nel redirect
		const isGerman = to.path.startsWith('/de/');
		const isEnglish = to.path.startsWith('/en/');
		const areaRiservataPath = isGerman ? '/de/geschutzter-bereich' : isEnglish ? '/en/reserved-area' : '/area-riservata';
		return next(areaRiservataPath);
	}

	// Verifica ReCaptcha (spostiamo questo controllo prima dell'auth)
	// se sono in sviluppo, non controllo il recaptcha
	const requiresRecaptcha = to.matched.some((record) => record.meta.requiresRecaptcha);
	if (requiresRecaptcha) {
		try {
			Recaptcha.initialize();
		} catch (error) {
			console.error('error reCaptcha', error);
			ErrorHandler.handleError(error);
			return next(false);
		}
	}

	// Controlli di autenticazione, alcune pagine sono accessibili anche da non loggati
	const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
	if (requiresAuth && !isLogged) {
		if (['segnalazione', 'nuovoAllacciamento', 'riesame', 'selectPosizioneICP',
			'affissione-manifesti', 'istanza-contribuente', 'proroga', 'mezzoPermanente', 'locandine', 'stragiudiziale'].includes(to.name as string)) {
			return next();
		}

		// prima, per sicurezza, ripulisco token, sessione e cache


		const authStore = useAuthStore();
		authStore.logout();
		const listStore = useListStore();
		listStore.$reset();

		// non serve, in teoria gli store hanno già fatto il loro dovere ma, per sicurezza, prevedo una azione aggressiva aggiuntiva
		sessionStorage.clear();
		localStorage.clear();


		// se restituisco semplicemente la rotta login vue carica la pagina ma non ha contenuto, devo fare fisicamente redirect a /login
		// così interviene il routing di wp che smisterà la richiesta al login di wordpress
		// Preserva la lingua nel redirect
		const isGerman = to.path.startsWith('/de/');
		const isEnglish = to.path.startsWith('/en/');
		window.location.href = isGerman ? '/de/logout' : isEnglish ? '/en/logout' : '/logout';

		return next(false);
	}

	next();
});

export default router;